var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,34.7c-0.5,0-0.8,0-1,0.1V38c0.2,0,0.5,0.1,0.8,0.1c1.3,0,2.1-0.7,2.1-1.8C19.3,35.3,18.6,34.7,17.4,34.7z M26.8,34.8 c-0.5,0-0.9,0-1.1,0.1v7.1c0.2,0,0.5,0,0.8,0c2.2,0,3.6-1.2,3.6-3.8C30.2,36,28.9,34.8,26.8,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,0.5H11.3c-3,0-5.4,2.4-5.4,5.4v43.2c0,3,2.4,5.4,5.4,5.4h32.4c3,0,5.4-2.4,5.4-5.4V16.7L32.9,0.5z M20.7,38.8 c-0.8,0.8-2.1,1.1-3.5,1.1c-0.3,0-0.6,0-0.8,0v3.9H14V33.1c1.1-0.2,2.2-0.2,3.3-0.2c1.5,0,2.6,0.3,3.3,0.9c0.7,0.5,1.2,1.4,1.2,2.5 C21.7,37.3,21.4,38.2,20.7,38.8z M31,42.5c-1.1,0.9-2.9,1.4-5,1.4c-1.3,0-2.2-0.1-2.8-0.2V33.1c1.1-0.2,2.2-0.2,3.3-0.2 c2,0,3.4,0.4,4.4,1.2c1.1,0.8,1.8,2.2,1.8,4.1C32.8,40.2,32.1,41.6,31,42.5z M41,35h-4.1v2.5h3.9v2h-3.9v4.3h-2.4V33H41 C41,33,41,35,41,35z M32.9,19.4h-2.7V5.9l13.5,13.5H32.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon01);
export default __webpack_public_path__ + "static/media/pdf_icon_01.fa60607a13844fa3ba3b3d202051d85b.svg";
export { ForwardRef as ReactComponent };